<div class="flex pb-0 pt-[0px] overflow-hidden">
    <div class="w-[100%] pr-[10px]">
      <!-- Header Section -->
      <div class="flex justify-between pl-[15px]">
        <div class="flex items-center gap-x-4">
          <h1 class="!text-[20px] !font-bold">Q&A</h1>
          <h1 class="!text-[20px] !font-bold">ADDENDUMS</h1>
        </div>
        <div class="flex items-center space-x-4">
          <mat-icon class="text-[#E76B3F]">help_outline</mat-icon>
          <mat-icon class="text-[#E76B3F]">settings</mat-icon>
          <mat-icon class="!text-black">close</mat-icon>
        </div>
      </div>
  
      <!-- Questions List -->
      <div class="bg-white shadow rounded-lg overflow-hidden">
        <div class="toolbar-content">
          <!-- <mat-checkbox></mat-checkbox> -->
          <button mat-icon-button>
            <mat-icon>arrow_drop_down</mat-icon>
          </button>
          <button mat-icon-button>
            <mat-icon>refresh</mat-icon>
          </button>
          <button mat-icon-button>
            <mat-icon>more_vert</mat-icon>
          </button>
          <span class="spacer"></span>
          <div class="pagination">
            <span>1-50 of 100</span>
            <button mat-icon-button>
              <mat-icon>chevron_left</mat-icon>
            </button>
            <button mat-icon-button>
              <mat-icon>chevron_right</mat-icon>
            </button>
          </div>
        </div>
  
        <div class="divide-y" *ngFor="let group of groupedQueries; let i = index">
          <div [ngClass]="{ 'bg-red-100': i === selectedQueryIndex }" class="p-4">
            
            <!-- Clickable group for queries -->
            <div class="cursor-pointer" (click)="toggleSelectedQueryDetails(i)">
              <div class="flex items-start space-x-2">
                <span class="text-gray-500 mt-[5px]">{{ formatQueryNumber(i) }}</span>
                <div class="flex flex-col">
                  <div *ngFor="let query of group.queries" class="flex items-start space-x-2">
                    <img [src]="query?.avatar" alt="User avatar" class="w-8 h-8 rounded-full" height="32" width="32"/>
                    <span class="font-semibold" [innerHTML]="getSanitizedHtml(query?.query)"></span>
                  </div>
                </div>
              </div>
            
        
            <!-- Show answer when the group is selected -->
             <ng-container *ngIf="selectedQueryIndex === i">
               <div class="mt-2 text-gray-700 !pl-[68px]">
                 <span [innerHTML]="getSanitizedHtml(group?.answer)"></span>
               
               
               <!-- Attach Files taken by drawings -->
               <div *ngIf="group?.attachedFiles" class="!max-h-[150px] overflow-y-auto">
                 <a
                 href="#"
                 #downloadRfpResponseDocumentLink
                   *ngFor="let file of group?.attachedFiles; let i = index"
                   class="!ml-[20px] text-black font-roboto text-[14px] font-normal leading-normal cursor-pointer "
                   (click)="
                     $event.stopPropagation();
                     downloadRfpResponseDocument(
                       $event,
                       downloadRfpResponseDocumentLink,
                       file
                     )
                   "
                 >
                 <div class="flex bg-[#E76B3F] text-[#FFFFFF] rounded-full px-4 py-[5px] w-[16vw]">
                 <div
                      class="relative ml-[5px] mr-[5px] w-[1rem] h-[1rem] overflow-hidden"
                    >
                      <img
                        [src]="getFileIcon(file)"
                        alt="File Preview"
                        class="object-cover w-auto h-[100%] cursor-pointer"
                      />
                    </div>
                 <span>{{ file?.name?.length > 20 ? (file?.name | slice :0:20) + '...' : file?.name }}</span>
                </div>
                </a>
               </div>
               <!-- Attach File Taken by Local drive -->
               <div *ngIf="group?.newFiles" class="!max-h-[150px] overflow-y-auto ">
                 <a
                  #downloadRfpResponseDocumentLink
                  href="#"
                   *ngFor="let file of group?.newFiles; let i = index"
                   class="!ml-[20px] text-black font-roboto text-[14px] font-normal leading-normal cursor-pointer "
                   (click)="
                     $event.stopPropagation();
                     downloadRfpResponseDocument(
                       $event,
                       downloadRfpResponseDocumentLink,
                       file
                     )
                   "
                 >
                 <div class="flex bg-[#E76B3F] text-[#FFFFFF] rounded-full px-4 py-[5px] w-[16vw]">
                  <div
                       class="relative ml-[5px] mr-[5px] w-[1rem] h-[1rem] overflow-hidden"
                     >
                       <img
                         [src]="getFileIcon(file)"
                         alt="File Preview"
                         class="object-cover w-auto h-[100%] cursor-pointer"
                       />
                     </div>
                  <span> {{ file?.title?.length > 20 ?  (file?.title | slice:0:20) + '...' : file?.title }}</span>
                 </div>
                </a>
               </div>
              </div>
             </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
  